import React from 'react';

const aiFeatures = [
  {
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 2a4 4 0 0 1 4 4c0 1.95-1.4 3.58-3.25 3.93"/><path d="M8.24 9.93A4 4 0 0 1 12 2"/><circle cx="12" cy="12" r="2"/>
        <path d="M16 20l-4-4-4 4"/><path d="M12 16v6"/><path d="M4.93 4.93l2.83 2.83"/><path d="M16.24 7.76l2.83-2.83"/>
      </svg>
    ),
    title: 'AI Shift Auto-Assignment',
    desc: 'Intelligent algorithms that auto-assign shifts based on employee skills, availability, preferences, and fairness scoring — no manual effort needed.',
    tag: 'Smart Scheduling',
  },
  {
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/>
      </svg>
    ),
    title: 'Predictive Staffing',
    desc: 'AI forecasts demand spikes based on historical patterns, holidays, and trends — so you always have the right number of people scheduled.',
    tag: 'Forecasting',
  },
  {
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M18 20V10"/><path d="M12 20V4"/><path d="M6 20v-6"/>
      </svg>
    ),
    title: 'Smart Conflict Detection',
    desc: 'Automatically detect and resolve scheduling conflicts, overtime violations, and compliance issues before they become problems.',
    tag: 'Automation',
  },
  {
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/>
      </svg>
    ),
    title: 'Auto Leave Balancing',
    desc: 'AI suggests optimal leave approval windows that maintain shift coverage while respecting employee preferences and work-life balance.',
    tag: 'Leave Intelligence',
  },
  {
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
      </svg>
    ),
    title: 'AI Chat Assistant',
    desc: 'A conversational assistant that lets managers and staff interact with the platform using natural language — "Show me who is free on Friday evening."',
    tag: 'NLP',
  },
  {
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
      </svg>
    ),
    title: 'Anomaly & Attendance Alerts',
    desc: 'Real-time AI-powered alerts for unusual patterns — frequent tardiness, buddy punching, ghost shifts, and irregular clock-in behavior.',
    tag: 'Detection',
  },
  {
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/>
      </svg>
    ),
    title: 'Automated Reporting',
    desc: 'AI generates weekly workforce reports with insights — labor cost trends, overtime analysis, coverage gaps, and actionable recommendations.',
    tag: 'Insights',
  },
  {
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/>
      </svg>
    ),
    title: 'Workflow Automation',
    desc: 'Set rules that trigger automatic actions — auto-approve certain leave types, auto-notify backup staff, auto-escalate unfilled shifts.',
    tag: 'Rules Engine',
  },
];

function AIComingSoon() {
  return (
    <section className="section ai-section" id="ai-capabilities">
      <div className="container">
        <div className="section-header">
          <div className="ai-badge">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/>
            </svg>
            AI-Powered &middot; Coming Soon
          </div>
          <h2 className="section-title">The Future of Workforce Management is Intelligent</h2>
          <p className="section-subtitle">
            We're building AI capabilities that will transform how you schedule, manage,
            and optimize your workforce. Here's what's on the horizon.
          </p>
        </div>

        <div className="ai-grid">
          {aiFeatures.map((f, i) => (
            <div className={`ai-card fade-in fade-in-delay-${(i % 4) + 1}`} key={i}>
              <div className="ai-card-header">
                <div className="ai-card-icon">{f.icon}</div>
                <span className="ai-card-tag">{f.tag}</span>
              </div>
              <h3 className="ai-card-title">{f.title}</h3>
              <p className="ai-card-desc">{f.desc}</p>
            </div>
          ))}
        </div>

        <div className="ai-bottom fade-in">
          <div className="ai-notify-box">
            <div className="ai-notify-content">
              <div className="ai-notify-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/>
                </svg>
              </div>
              <div>
                <div className="ai-notify-title">Be the First to Experience AI-Powered Workforce Management</div>
                <div className="ai-notify-desc">
                  Our AI features are in active development and rolling out soon.
                  Get started with 9works today and get early access when AI capabilities launch.
                </div>
              </div>
            </div>
            <a href="https://9works.in/organisation-portal" className="btn btn-primary" target="_blank" rel="noopener noreferrer">
              Get Early Access
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default AIComingSoon;
